import { defineMessages } from 'react-intl'

export default defineMessages({
  error: {
    id: 'containers.EmbeddedDealPage.error',
    defaultMessage: 'An error occured',
  },
  saving: {
    id: 'containers.EmbeddedDealPage.saving',
    defaultMessage: 'Saving..'
  },
  save: {
    id: 'containers.EmbeddedDealPage.save',
    defaultMessage: 'Save',
  },
  cancel: {
    id: 'containers.EmbeddedDealPage.cancel',
    defaultMessage: 'Cancel',
  },
  dealInProgress: {
    id: 'containers.EmbeddedDealPage.dealInProgress',
    defaultMessage: 'Deal in progress'
  },
  closed: {
    id: 'containers.EmbeddedDealPage.closed',
    defaultMessage: 'Order closed',
  },
  orderInProgress: {
    id: 'containers.EmbeddedDealPage.orderInProgress',
    defaultMessage: 'Order in progress',
  },
  openOrder: {
    id: 'containers.EmbeddedDealPage.openOrder',
    defaultMessage: 'Open order #{id}',
  },
})
